import { useUser } from '../providers/user/useUser';
import { showReferAFriend } from '../services/showReferAFriend';

export function useShowReferAfriend() {
    const { user } = useUser();

    if (!user) {
        return false;
    }

    return showReferAFriend(user);
}
